const { post } = require('../fetch')

const server = async (formula, results) => {
    try{
        const resp = await post(`predict/${formula}`, { results: results.join('') })
        return resp.data.prediction || 'X';
    } catch(err) {
        console.log(err)
        return 'X'
    }
    return 'X'
}

export default (formula) => {
    return (results) => server(formula, results)
}